// Корневой компонент: маршрутизация по #/ (список отчётов), #/p/<id> (редактор) и #/admin/<вкладка>
// (администрирование), тема, подсказки, палитра.
import { useEffect } from 'react';
import { api } from '../core/api';
import { appStore, useApp } from '../core/store';
import { openProject, closeProject } from '../core/project';
import { ctx } from '../core/ctx';
import { StartScreen } from './StartScreen';
import { Shell } from './Shell';
import { DialogHost, ToastHost } from './Hosts';
import { TooltipHost } from './controls';
import { applyTheme } from './uiState';
import { CommandPalette } from '../features/shell/palette';
import { AdminScreen, useAdminRoute } from '../features/admin/AdminScreen';

async function route() {
  const m = location.hash.match(/^#\/p\/(.+)$/);
  const s = appStore.getState();
  if (m) {
    const id = decodeURIComponent(m[1]);
    if (s.projectId !== id) {
      if (s.projectId) await closeProject();
      try { await openProject(id); } catch (e: any) { ctx.toast(e.message, 'error', 8000); location.hash = '#/'; }
    }
  } else if (s.projectId) {
    await closeProject();
  } else {
    s.set({ view: 'start' });
  }
}

export function App() {
  const view = useApp((s) => s.view);
  const pid = useApp((s) => s.projectId);
  const admin = useAdminRoute();
  useEffect(() => {
    applyTheme();
    api.defaults().then((d) => appStore.getState().set({ defaults: d })).catch(() => { /* сервер недоступен - покажет список */ });
    const on = () => { void route(); };
    window.addEventListener('hashchange', on);
    void route();
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return (
    <>
      {admin ? <AdminScreen tab={admin.tab} query={admin.query} /> : view === 'editor' && pid ? <Shell key={pid} /> : <StartScreen />}
      <DialogHost />
      <CommandPalette />
      <ToastHost />
      <TooltipHost />
    </>
  );
}
